// Polyfills
// import './utilities/polyfills';

// Plugins
import './plugins/lazyLoad';
import './plugins/cart-note';

// Behaviors
import { initBehaviors, destroyBehaviors } from './behaviors';

// Utilities
import { handleRedirect } from './utilities/handleRedirect';
import { cacheProductData } from './utilities/productData';

// Initialize behaviors after DOM Content Loaded (so template polyfill is sure to be in effect)
window.addEventListener('DOMContentLoaded', () => {
  initBehaviors();
  cacheProductData();
});


//Shopify theme editor listeners

window.addEventListener('shopify:section:load' , () => {
  destroyBehaviors();
  initBehaviors();
});

// Product data
handleRedirect();
